import ObserverExample from "./examples/Observer.Example";

export default [
    {
        title: "Observer example",
        component: ObserverExample,
        code: require("!raw-loader!./examples/Observer.Example.tsx")
    }
];
